<template>
    <div class="forex-menu-box">
        <div class="forex-menu pc">
            <div class="forex-menu-pc-box no-scrollbar">
                <div class="forex-menu-group">
                    <div class="forex-menu-title menu-icon1">学习中心</div>
                    <a href="/jinrong/cidian/" data-link="/jinrong/cidian/" class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('cidian') }">交易词典</a>
                    <a href="/jinrong/jinrongzhishi/"
                        data-link="/jinrong/jinrongzhishi/ /jinrong/waihuizhishi/ /jinrong/guijinshuzhishi/ /jinrong/nengyuanzhishi/ /jinrong/gupiaozhishi/ /jinrong/zhishuzhishi/ /jinrong/jijinzhishi/ /jinrong/jianguan/ /jinrong/xunihuobi/ /jinrong/zhongyaoshuju/ /jinrong/qita/"
                        class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('jinrongzhishi,waihuizhishi,guijinshuzhishi,nengyuanzhishi,gupiaozhishi,zhishuzhishi,jijinzhishi,jianguan,xunihuobi,zhongyaoshuju,qita') }">金融知识</a>
                    <a href="/jinrong/dashi/" data-link="/jinrong/dashi/ /jinrong/shuji/" class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('dashi,shuji') }">市场传奇</a>
                    <!-- <a href="/webinars"
                        data-link="/webinars /jinrong/rumen/ /jinrong/jinjie/ /jinrong/gaojie/"
                        class="forex-menu-link" :class="{'isCurrentLink':isCurrentLinkFn('webinars,rumen,jinjie,gaojie')}">在线课程</a> -->
                </div>
                <div class="forex-menu-group">
                    <div class="forex-menu-title menu-icon2">市场研究</div>
                    <a href="/jinrong/jinrongjiaodian/"
                        data-link="/jinrong/jinrongjiaodian/ /jinrong/waihuixinwen/ /jinrong/guijinshuxinwen/ /jinrong/nengyuanxinwen/ /jinrong/gupiaoxinwen/ /jinrong/zhishuxinwen/ /jinrong/jijinxinwen/ /jinrong/qitajingjixinwen/"
                        class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('jinrongjiaodian,waihuixinwen,guijinshuxinwen,nengyuanxinwen,gupiaoxinwen,zhishuxinwen,jijinxinwen,qitajingjixinwen') }">金融焦点</a>
                    <a href="/jinrong/shujubaogao/"
                        data-link="/jinrong/shujubaogao/ /jinrong/jigoushuju/ /jinrong/feinongshuju/ /jinrong/yanghanglilv/ /jinrong/gdpshuju/ /jinrong/meiguocpishuju/ /jinrong/meiguopceshuju/ /jinrong/lingshoushuju/ /jinrong/eiashuju/ /jinrong/meiguochuqing/ /jinrong/qitashuju/"
                        class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('shujubaogao,jigoushuju,feinongshuju,yanghanglilv,gdpshuju,meiguocpishuju,meiguopceshuju,lingshoushuju,eiashuju,zengjianxianji,meiguochuqing,qitashuju') }">数据报告</a>

                    <a href="/jinrong/shichangfenxi/" data-link="/jinrong/shichangfenxi/" class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('shichangfenxi') }">市场分析</a>
                    <a href="/jinrong/shichangqikan/" data-link="/jinrong/shichangqikan/" class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('shichangqikan') }">市场期刊</a>
                </div>
                <div class="forex-menu-group">
                    <div class="forex-menu-title menu-icon3">交易工具</div>
                    <!-- <a href="/jinrong/mt4/"
                        data-link="/jinrong/mt4/ /jinrong/mt5/ /jinrong/trading-central/ /jinrong/trading-view/"
                        class="forex-menu-link" :class="{'isCurrentLink':isCurrentLinkFn('mt4,mt5,trading-central,trading-view')}">交易软件</a> -->
                    <a href="/jinrong/dingdanliu/" data-link="/jinrong/dingdanliu/" class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('dingdanliu') }">订单流</a>
                    <a href="/jinrong/ebc-ea-turbo/" data-link="/jinrong/ebc-ea-turbo/ /jinrong/ea/"
                        class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('ebc-ea-turbo,ea') }">EA工具库</a>
                    <a href="/forex-tools/" data-link="/forex-tools/" class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('forex-tools,pivot-points-calculator,fibonacci-calculator,pip-value-calculator,position-size-calculator,risk-reward-calculator,gain-loss-percentage-calculator') }">交易计算器</a>
                    <a href="/caijingzhouli/" data-link="/caijingzhouli/" class="forex-menu-link"
                        :class="{ 'isCurrentLink': isCurrentLinkFn('caijingzhouli') }">财经日历</a>
                </div>
            </div>
        </div>
        <!-- forex-menu-mobile -->
        <div class="mobile">
            <nav class="forex-menu-mobile-link-box no-scrollbar">
                <a href="/jinrong/cidian/" data-link="/jinrong/cidian/" class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('cidian') }">交易词典</a>
                <a href="/jinrong/jinrongzhishi/"
                    data-link="/jinrong/jinrongzhishi/ /jinrong/waihuizhishi/ /jinrong/guijinshuzhishi/ /jinrong/nengyuanzhishi/ /jinrong/gupiaozhishi/ /jinrong/zhishuzhishi/ /jinrong/jijinzhishi/ /jinrong/jianguan/ /jinrong/xunihuobi/ /jinrong/zhongyaoshuju/ /jinrong/qita/"
                    class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('jinrongzhishi,waihuizhishi,guijinshuzhishi,nengyuanzhishi,gupiaozhishi,zhishuzhishi,jijinzhishi,jianguan,xunihuobi,zhongyaoshuju,qita') }">金融知识</a>
                <a href="/jinrong/dashi/" data-link="/jinrong/dashi/ /jinrong/shuji/" class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('dashi,shuji') }">市场传奇</a>
                <!-- <a href="/webinars"
                    data-link="/webinars /jinrong/rumen/ /jinrong/jinjie/ /jinrong/gaojie/"
                    class="forex-menu-mobile-link">在线课程</a> -->
                <a href="/jinrong/jinrongjiaodian/"
                    data-link="/jinrong/jinrongjiaodian/ /jinrong/waihuixinwen/ /jinrong/guijinshuxinwen/ /jinrong/nengyuanxinwen/ /jinrong/gupiaoxinwen/ /jinrong/zhishuxinwen/ /jinrong/jijinxinwen/ /jinrong/qitajingjixinwen/"
                    class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('jinrongjiaodian,waihuixinwen,guijinshuxinwen,nengyuanxinwen,gupiaoxinwen,zhishuxinwen,jijinxinwen,qitajingjixinwen') }">金融焦点</a>
                <a href="/jinrong/shujubaogao/"
                    data-link="/jinrong/shujubaogao/ /jinrong/huangjin/ /jinrong/yuanyou/ /jinrong/gupiaozhishu/ /jinrong/hongguanjingji/"
                    class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('shujubaogao,jigoushuju,feinongshuju,yanghanglilv,gdpshuju,meiguocpishuju,meiguopceshuju,lingshoushuju,eiashuju,zengjianxianji,meiguochuqing,qitashuju') }">数据报告</a>
                <a href="/jinrong/shichangfenxi/" data-link="/jinrong/shichangfenxi/" class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('shichangfenxi') }">市场分析</a>
                <a href="/jinrong/shichangqikan/" data-link="/jinrong/shichangqikan/" class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('shichangqikan') }">市场期刊</a>
                <!-- <a href="/jinrong/mt4/"
                    data-link="/jinrong/mt4/ /jinrong/mt5/ /jinrong/trading-central/ /jinrong/trading-view/"
                    class="forex-menu-mobile-link" :class="{'isCurrentMobileLink':isCurrentMobileLinkFn('mt4,mt5,trading-central,trading-view')}">交易软件</a> -->
                <a href="/jinrong/dingdanliu/" data-link="/jinrong/dingdanliu/" class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('dingdanliu') }">订单流</a>
                <a href="/jinrong/ebc-ea-turbo/" data-link="/jinrong/ebc-ea-turbo/ /jinrong/ea/"
                    class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('ebc-ea-turbo,ea') }">EA工具库</a>
                <a href="/forex-tools/" data-link="/forex-tools/" class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('forex-tools,pivot-points-calculator,fibonacci-calculator,pip-value-calculator,position-size-calculator,risk-reward-calculator,gain-loss-percentage-calculator') }">交易计算器</a>
                <a href="/caijingzhouli/" data-link="/caijingzhouli/" class="forex-menu-mobile-link"
                    :class="{ 'isCurrentMobileLink': isCurrentMobileLinkFn('caijingzhouli') }">财经日历</a>
            </nav>
            <div class="more-btn-box">
                <div class="more-btn">
                    <div id="menuShowBtn" class="menu-show-btn">
                        <span class="iconfont icon-navigate-down"></span>
                    </div>
                    <div class="all-menu-box">
                        <div class="forex-link-group">
                            <div class="forex-link-title menu-icon1">学习中心</div>
                            <div class="forex-link-tag-box">
                                <a href="/jinrong/cidian/" data-link="/jinrong/cidian/" class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('cidian') }">交易词典</a>
                                <a href="/jinrong/jinrongzhishi/"
                                    data-link="/jinrong/jinrongzhishi/ /jinrong/waihuizhishi/ /jinrong/guijinshuzhishi/ /jinrong/nengyuanzhishi/ /jinrong/gupiaozhishi/ /jinrong/zhishuzhishi/ /jinrong/jijinzhishi/ /jinrong/jianguan/ /jinrong/xunihuobi/ /jinrong/zhongyaoshuju/ /jinrong/qita/"
                                    class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('jinrongzhishi,waihuizhishi,guijinshuzhishi,nengyuanzhishi,gupiaozhishi,zhishuzhishi,jijinzhishi,jianguan,xunihuobi,zhongyaoshuju,qita') }">金融知识</a>
                                <a href="/jinrong/dashi/" data-link="/jinrong/dashi/ /jinrong/shuji/"
                                    class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('dashi,shuji') }">市场传奇</a>
                                <!-- <a href="/webinars"
                                    data-link="/webinars /jinrong/rumen/ /jinrong/jinjie/ /jinrong/gaojie/"
                                    class="forex-link-tag">在线课程</a> -->
                            </div>
                        </div>
                        <div class="forex-link-group">
                            <div class="forex-link-title menu-icon2">市场研究</div>
                            <div class="forex-link-tag-box">
                                <a href="/jinrong/jinrongjiaodian/"
                                    data-link="/jinrong/jinrongjiaodian/ /jinrong/waihuixinwen/ /jinrong/guijinshuxinwen/ /jinrong/nengyuanxinwen/ /jinrong/gupiaoxinwen/ /jinrong/zhishuxinwen/ /jinrong/jijinxinwen/ /jinrong/qitajingjixinwen/"
                                    class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('jinrongjiaodian,waihuixinwen,guijinshuxinwen,nengyuanxinwen,gupiaoxinwen,zhishuxinwen,jijinxinwen,qitajingjixinwen') }">金融焦点</a>
                                <a href="/jinrong/shujubaogao/"
                                    data-link="/jinrong/shujubaogao/ /jinrong/jigoushuju/ /jinrong/feinongshuju/ /jinrong/yanghanglilv/ /jinrong/gdpshuju/ /jinrong/meiguocpishuju/ /jinrong/meiguopceshuju/ /jinrong/lingshoushuju/ /jinrong/eiashuju/ /jinrong/meiguochuqing/ /jinrong/qitashuju/"
                                    class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('shujubaogao,jigoushuju,feinongshuju,yanghanglilv,gdpshuju,meiguocpishuju,meiguopceshuju,lingshoushuju,eiashuju,zengjianxianji,meiguochuqing,qitashuju') }">数据报告</a>
                                <a href="/jinrong/shichangfenxi/" data-link="/jinrong/shichangfenxi/"
                                    class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('shichangfenxi') }">市场分析</a>
                                <a href="/jinrong/shichangqikan/" data-link="/jinrong/shichangqikan/"
                                    class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('shichangqikan') }">市场期刊</a>
                            </div>
                        </div>
                        <div class="forex-link-group">
                            <div class="forex-link-title menu-icon3">交易工具</div>
                            <div class="forex-link-tag-box">
                                <!-- <a href="/jinrong/mt4/"
                                    data-link="/jinrong/mt4/ /jinrong/mt5/ /jinrong/trading-central/ /jinrong/trading-view/"
                                    class="forex-link-tag" :class="{'forex-link-tag-selected':isForexLinkTagSelectedFn('mt4,mt5,trading-central,trading-view')}">交易软件</a> -->
                                <a href="/jinrong/dingdanliu/" data-link="/jinrong/dingdanliu/" class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('dingdanliu') }">订单流</a>
                                <a href="/jinrong/ebc-ea-turbo/" data-link="/jinrong/ebc-ea-turbo/ /jinrong/ea/"
                                    class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('ebc-ea-turbo,ea') }">EA工具库</a>
                                <a href="/forex-tools/" data-link="/forex-tools/" class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('forex-tools,pivot-points-calculator,fibonacci-calculator,pip-value-calculator,position-size-calculator,risk-reward-calculator,gain-loss-percentage-calculator') }">交易计算器</a>
                                <a href="/caijingzhouli/" data-link="/caijingzhouli/" class="forex-link-tag"
                                    :class="{ 'forex-link-tag-selected': isForexLinkTagSelectedFn('caijingzhouli') }">财经日历</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['linkname'],
    mounted() {

        document.addEventListener("DOMContentLoaded", function () {
            // 获取所有 .menu-show-btn 元素（如果有多个）
            const menuShowBtns = document.querySelectorAll(".menu-show-btn");

            // 遍历每个按钮
            menuShowBtns.forEach((btn) => {
                btn.addEventListener("click", function (e) {
                    e.stopPropagation(); // 阻止事件冒泡到 document

                    // 找到当前按钮所在的 .more-btn-box 容器
                    const moreBtnBox = btn.closest(".more-btn-box");

                    if (moreBtnBox) {
                        moreBtnBox.classList.toggle("forex-menu-mobile-show");
                    }
                });
            });

            // 点击文档任意地方，如果不在 .more-btn-box 内，则关闭菜单
            document.addEventListener("click", function (e) {
                // 查找所有 .more-btn-box 元素
                const allMenus = document.querySelectorAll(".more-btn-box");

                allMenus.forEach((menu) => {
                    // 如果点击的目标不在当前菜单内
                    if (!menu.contains(e.target)) {
                        menu.classList.remove("forex-menu-mobile-show");
                    }
                });
            });
        });

        document.addEventListener("DOMContentLoaded", function () {
            // 获取当前页面的路径（去除域名和查询参数）
            const currentPath = window.location.pathname;

            let breadcrumbLink = document.querySelectorAll(".breadcrumb-link");
            let breadcrumbLinkFlag = breadcrumbLink && breadcrumbLink[1];

            // 高亮函数：通用处理逻辑
            function highlightLinks(selector, className) {
                document.querySelectorAll(selector).forEach((link) => {
                    const dataLink = link.getAttribute("data-link");
                    let linkName = link.innerText;
                    if (dataLink) {
                        const paths = dataLink.split(" "); // 用空格分割多个路径

                        // 判断当前路径是否匹配其中之一
                        const isActive = paths.some((path) => {
                            let result = false;
                            if (breadcrumbLinkFlag) {
                                return (
                                    (path && currentPath.startsWith(path)) ||
                                    linkName == breadcrumbLink[1].innerText
                                );
                            } else {
                                return path && currentPath.startsWith(path);
                            }
                        });

                        if (isActive) {
                            link.classList.add(className);
                        }
                    }
                });
            }

            // 调用高亮函数
            // highlightLinks(".forex-menu-link", "isCurrentLink");
            // highlightLinks(".forex-menu-mobile-link", "isCurrentMobileLink");
            highlightLinks(".forex-link-tag", "forex-link-tag-selected");

            // 获取导航容器和当前活动链接
            const navContainer = document.querySelector(".forex-menu-mobile-link-box");
            const currentLink = document.querySelector(".isCurrentMobileLink");
            // 如果找到当前活动链接
            if (currentLink && navContainer) {
                // 计算需要滚动的距离
                const scrollLeft = currentLink.offsetLeft - navContainer.offsetLeft;

                // 平滑滚动到目标位置
                navContainer.scrollTo({
                    left: scrollLeft,
                    behavior: "smooth",
                });

                // 也可以直接设置（无动画效果）
                // navContainer.scrollLeft = scrollLeft;
            }
        });

    },
    methods: {
        isCurrentLinkFn(target) {
            if (!target || target === '') {
                return false;
            }


            // 获取当前路由名称
            const currentRouteName = this.$route.name == "detail" ? this.linkname : this.$route.name;

            // 如果当前路由没有名称，返回 false
            if (!currentRouteName) {
                return false;
            }

            // 将传入的 target 参数按逗号分割成数组
            const targetKeys = target.split(',').map(key => key.trim());

            // 检查当前路由名称是否在 target 数组中
            return targetKeys.includes(currentRouteName);
        },
        isCurrentMobileLinkFn(target) {
            if (!target || target === '') {
                return false;
            }


            // 获取当前路由名称
            const currentRouteName = this.$route.name == "detail" ? this.linkname : this.$route.name;

            // 如果当前路由没有名称，返回 false
            if (!currentRouteName) {
                return false;
            }

            // 将传入的 target 参数按逗号分割成数组
            const targetKeys = target.split(',').map(key => key.trim());

            // 检查当前路由名称是否在 target 数组中
            return targetKeys.includes(currentRouteName);
        },
        isForexLinkTagSelectedFn(target) {
            if (!target || target === '') {
                return false;
            }


            // 获取当前路由名称
            const currentRouteName = this.$route.name == "detail" ? this.linkname : this.$route.name;

            // 如果当前路由没有名称，返回 false
            if (!currentRouteName) {
                return false;
            }

            // 将传入的 target 参数按逗号分割成数组
            const targetKeys = target.split(',').map(key => key.trim());

            // 检查当前路由名称是否在 target 数组中
            return targetKeys.includes(currentRouteName);
        }
    }
}
</script>

<style scoped>
.forex-menu-box {
    position: sticky;
    top: 144rem;
    width: 146rem;
    /* padding-top: 88rem; */
    /* padding-bottom: 100rem; */
    font-size: 16rem;
    height: 100%;
    flex-shrink: 0;
}

.forex-menu-pc-box {
    display: flex;
    flex-direction: column;
    gap: 40rem;
    max-height: calc(100vh - 88rem);
    overflow-y: auto;
}

.forex-menu-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.forex-menu-group:first-child {
    margin-top: 0;
}

.forex-menu-title {
    color: var(--Text-Tertiary, rgba(0, 0, 0, 0.48));
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 28rem;
}

.forex-menu-link {
    position: relative;
    margin-top: 12rem;
    color: var(--Text-Primary, #000);
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24rem;
    transition: all 0.27s;
}



.isCurrentLink::before {
    color: #a52933;
}

.isCurrentLink,
.forex-menu-link:hover {
    color: #a52933;
    /* font-weight: 700; */
}

.isCurrentLink,
.forex-menu-link:hover::before {
    color: #a52933;
}

.forex-menu-mobile {
    display: none;
}

@media (max-width: 1440px) {
    .forex-menu-box {
        left: 40rem;
    }
}

@media (max-width: 996px) {
    .menu-show-btn {
        position: absolute;
        right: 0;
        top: 0;
        display: inline-flex;
        padding-right: 30rem;
        justify-content: flex-end;
        align-items: center;
        height: 130rem;
        background: linear-gradient(to right,
                transparent 0,
                #ffffff 40%,
                #ffffff 100%);
        width: 150rem;
    }

    .forex-menu-box {
        display: block;
        position: sticky;
        top: 44px;
        left: 0;
        width: 100%;
        background: #fff;
        z-index: 998;
    }

    .forex-menu-mobile-link-box {
        display: inline-flex;
        align-items: center;
        height: 130rem;
        width: 100%;
        gap: 40rem;
        overflow: hidden;
        overflow-x: scroll;
        padding: 0 150rem 0 0;
    }

    .forex-menu-mobile-link {
        position: relative;
        flex-shrink: 0;
        display: inline-block;
        color: #232222;
        font-size: 28rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .isCurrentMobileLink,
    .forex-menu-mobile-link:hover {
        color: #a52933;
    }

    .isCurrentMobileLink::after,
    .forex-menu-mobile-link:hover::after {
        content: "";
        width: 40rem;
        height: 2px;
        border-radius: 2px;
        background-color: #a52933;
        position: absolute;
        bottom: -16rem;
        left: calc(50% - 20rem);
    }

    .icon-navigate-down {
        font-size: 40rem;
        color: #b2afad;
        transition: transform 0.3s;
    }

    .all-menu-box {
        display: none;
        padding: 32rem 30rem;
        position: absolute;
        top: 130rem;
        left: -30rem;
        width: calc(100% + 60rem);
        background-color: #fff;
        min-height: 100vh;
    }

    .forex-menu-mobile-show .all-menu-box {
        display: block;
    }

    .forex-menu-mobile-show .icon-navigate-down {
        transform: rotate(180deg);
    }

    .forex-link-title {
        position: relative;
        color: #9f734c;
        font-size: 28rem;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 32rem;
        padding-left: 56rem;
        padding-bottom: 0;
    }

    .menu-icon1::before,
    .menu-icon2::before,
    .menu-icon3::before {
        font-size: 40rem;
    }

    .forex-link-tag-box {
        display: flex;
        flex-wrap: wrap;
        gap: 24rem;
        margin-bottom: 48rem;
    }

    .forex-link-tag {
        color: #232222;
        font-size: 28rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 8rem;
        background: #f9fafc;
        border: 1px solid #f9fafc;
        height: 68rem;
        padding: 0 28rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .forex-link-tag:hover,
    .forex-link-tag-selected {
        background: #fff;
        border: 1px solid #a52933;
        color: #a52933;
    }
}
</style>